import React, { useState } from 'react';
import { Typography, Modal, Table } from 'antd';
import { amountToString } from '../util/tool';
import { accAdd } from '../util/math';

const titleStyle = {
  fontSize: '16px',
  fontWeight: 600,
  color: '#333333',
  lineHeight: '22px',
  textAlign: 'center',
};
const tableStyle = {
  margin: '20px'
};
const columns = [
  {
    title: 'name',
    dataIndex: 'key',
    key: 'key',
    align: 'center',
    width: 120
  },
  {
    title: 'value',
    dataIndex: 'value',
    key: 'value',
    align: 'right',
    width: 120,
    render: (text) => {
      return `¥` + (text >= 0 ? amountToString(+text) : `-${amountToString(Math.abs(+text))}`);
    }
  },
  {
    title: 'desc',
    dataIndex: 'desc',
    key: 'desc',
    align: 'center',
    width: 120
  },
];

export default function RenderPopover(props = {}) {
  const [modalVisible, setModalVisible] = useState(false);
  const { record , type} = props;
  const { submit_status, qoute } = record;
  const { surcharge_desc = [] } = qoute || {};
  const [first, ...res] = surcharge_desc;
  const notIncluded = (res || []).filter(item => !item.add_price).map((item, index) => ({ ...item, id: index }));
  const included = (res || []).filter(item => item.add_price).map((item, index) => ({ ...item, id: index }));
  const title1 = first && `${first.key}：¥${amountToString(+first.value)}`;
  const title2 = '费用总计：¥' + (included.reduce((Accumulator, Current) => accAdd((+Accumulator), (+Current?.value || 0)), 0));
  const price = (type === 1) && <div style={{ flex: 1, textAlign: 'right' }}>{'¥' + amountToString(record?.goods?.sale_price || 0)}</div>;
  const popoverContext = surcharge_desc?.length ? <Typography.Link style={{ width: '40px' }} onClick={() => openModal()}>明细</Typography.Link> : null;
  const finallyText = submit_status === 3 ? '-' : <div style={{ display: 'flex', justifyContent: `${type === 1 ? 'space-between' : 'center'}` }}>{price}{popoverContext}</div>;
  const openModal = () => {
    setModalVisible(true);
  };
  const handleCancel = () => {
    setModalVisible(false);
  };
  return (<>
    <div> {finallyText}</div>
    <Modal
      open={modalVisible}
      centered
      footer={false}
      onCancel={handleCancel}
      width={700}
    >
      <div style={{ height: '400px', overflowY: 'scroll' }}>
        <div>
          <div style={titleStyle}>商品单价详情</div>
          <div>{title1}</div>
          {notIncluded?.length ?
            <Table
              bordered
              style={tableStyle}
              showHeader={false}
              dataSource={notIncluded || []}
              columns={columns}
              rowKey='id'
              pagination={false}
            />
            : null
          }
        </div>
        {included?.length ?
          <div style={{ marginTop: '20px' }}>
            <div style={titleStyle}>费用明细</div>
            <div>{title2}</div>
            <Table
              style={tableStyle}
              bordered
              showHeader={false}
              dataSource={included || []}
              columns={columns}
              rowKey='id'
              pagination={false}
            />
          </div> : null
        }
      </div>

    </Modal>
  </>);
}
